var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useState } from "react";
import "../InitiateRefundForm/initiate-refund-form.scss";
import { useSelector } from "react-redux";
import InputComponent from "@frameworks/NCD/Components/InputComponent";
import AccordionComponent from "@frameworks/NCD/Components/AccordionComponent";
import FileUploadComponent from "@frameworks/NCD/Components/FileUploadComponent";
import "@frameworks/shared-library/stylesheets/components/NCD/product-bouquet.scss";
import BankSelector from "@frameworks/NCD/Components/BankSelector";
import actions from "@redux/feature/Markets/NCD/actions/OrderBookActions";
import RefundSearch from "@frameworks/NCD/Components/RefundSearch";
import { floatNumExp } from "@frameworks/salesjourney/utils/regex";
import { debounce } from "underscore";
import otcDi from "../../../../../../../mainDi/features/OTC/servicelocator";
var SuspenseForm = function () {
    var _a, _b, _c;
    var cActions = new actions();
    var _d = __read(useState({ error: null, isOpen: false }), 2), errorData = _d[0], setErrorData = _d[1];
    var _e = useSelector(function (state) { return state.markets.Otc.orderBookReducer; }), selectedRefundType = _e.selectedRefundType, suspenseFormData = _e.suspenseFormData;
    var _f = __read(useState(false), 2), isInvalid = _f[0], setInvalid = _f[1];
    var handleChange = function (event) {
        var _a;
        var _b = event.target, name = _b.name, value = _b.value;
        cActions.setSuspenseForm(__assign(__assign({}, suspenseFormData), (_a = {}, _a[name] = value.toUpperCase(), _a)));
        if (name === "ifscCode") {
            var ifscPattern = /^[A-Za-z]{4}0{1}[A-Za-z0-9]{6}$/;
            setInvalid(!ifscPattern.test(value.toUpperCase()));
        }
    };
    var debouncedInputUtrHandler = useCallback(debounce(function (inputValue) {
        validateUtrNumber(inputValue);
    }, 500), []);
    var validateUtrNumber = function (inputValue) { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, otcDi.orderBook.validateUTR({
                            urt_ref_no: String(inputValue),
                        })];
                case 1:
                    res = _a.sent();
                    setErrorData({
                        error: res === null || res === void 0 ? void 0 : res.data,
                        isOpen: false,
                    });
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    setErrorData({
                        error: { status: "Failed", message: "Validation error" },
                        isOpen: true,
                    });
                    return [3 /*break*/, 4];
                case 3: return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleChangeUtrNumber = function (event) {
        var inputValue = event.target.value;
        cActions.setSuspenseForm(__assign(__assign({}, suspenseFormData), { utrOrChequeNo: inputValue.toUpperCase() }));
        debouncedInputUtrHandler(inputValue);
    };
    return (React.createElement("div", { className: "initiate-refund-form d-flex flex-column gap-28 otc-product-bouquet-wrapper pb-20" },
        React.createElement("div", { className: "d-flex flex-column gap-2" },
            React.createElement("h2", { className: "txt-midnight-blue-shade2 DMSansNormal_20_400 d-flex align-items-center mb-0 gap-2 text-nowrap" },
                "Initiate Refund: ", selectedRefundType === null || selectedRefundType === void 0 ? void 0 :
                selectedRefundType.name),
            React.createElement("p", { className: "txt-whispering-periwinkle DMSansNormal_12_400" }, "When payment is made from someone else\u2019s account (e.g., spouse, friend, or relative).")),
        React.createElement("form", { className: "d-flex flex-column gap-20" },
            React.createElement("div", { className: "d-flex align-items-start gap-2 new-mandate-section primary-aif-pms-sidebar-container bg-white" },
                React.createElement("div", { className: "w-100 dropdown-container" },
                    React.createElement(RefundSearch, null))),
            React.createElement("div", { className: "d-flex align-items-start gap-2 new-mandate-section primary-aif-pms-sidebar-container bg-white" },
                React.createElement("div", { className: "w-100 dropdown-container" },
                    React.createElement(BankSelector, null))),
            React.createElement(InputComponent, { label: "Account Number", placeholder: "Enter account number", required: true, integer: true, isInvalid: false, helperText: "", name: "accountNumber", errorText: "", passErrorTextButHideErrTxt: true, onChangeEvent: handleChange, value: suspenseFormData === null || suspenseFormData === void 0 ? void 0 : suspenseFormData.accountNumber }),
            React.createElement(InputComponent, { label: "IFSC Code", placeholder: "Enter IFSC Code", required: true, alphanum: true, isInvalid: isInvalid, helperText: "", name: "ifscCode", errorText: "Invalid IFSC Code format. It should be 4 letters, 1 zeroes, and 6 alphanumeric characters.", passErrorTextButHideErrTxt: true, onChangeEvent: handleChange, value: suspenseFormData === null || suspenseFormData === void 0 ? void 0 : suspenseFormData.ifscCode }),
            React.createElement(InputComponent, { label: "Enter Amount to be Refunded", placeholder: "Enter Amount", required: true, float: floatNumExp(2), isInvalid: false, helperText: "", name: "amount", errorText: "", passErrorTextButHideErrTxt: true, onChangeEvent: handleChange, value: suspenseFormData === null || suspenseFormData === void 0 ? void 0 : suspenseFormData.amount }),
            React.createElement(InputComponent, { label: "UTR No. / Cheque No.", placeholder: "Enter UTR No. / Cheque No.", required: true, alphanum: true, isInvalid: ((_a = errorData === null || errorData === void 0 ? void 0 : errorData.error) === null || _a === void 0 ? void 0 : _a.status) === "Failed", helperText: "", name: "utrOrChequeNo", errorText: (_b = errorData === null || errorData === void 0 ? void 0 : errorData.error) === null || _b === void 0 ? void 0 : _b.message, passErrorTextButHideErrTxt: true, onChangeEvent: handleChangeUtrNumber, value: suspenseFormData === null || suspenseFormData === void 0 ? void 0 : suspenseFormData.utrOrChequeNo }),
            React.createElement("div", { className: "bank-upload order-book-upload" },
                React.createElement(AccordionComponent, { items: [
                        {
                            header: "Upload Bank Proof",
                            body: (React.createElement(FileUploadComponent, { fileSize: 5, withoutApiFunctionality: true, localStateSaveCallback: function (data) {
                                    cActions.setSuspenseForm(__assign(__assign({}, suspenseFormData), { bankProof: data }));
                                } })),
                            optional: false,
                            leftIcon: null,
                            info: false,
                        },
                    ], isDefalutKey: "0", isSuspenseForm: ((_c = suspenseFormData === null || suspenseFormData === void 0 ? void 0 : suspenseFormData.bankProof) === null || _c === void 0 ? void 0 : _c.length) > 0 ? false : true })))));
};
export default SuspenseForm;
